import React from "react";
import { personalInfo } from "../data/portfolioData";

const Home: React.FC = () => {
  return (
    <section id="home" className="section-padding relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-500/10 rounded-full blur-3xl floating-element"></div>
        <div
          className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent-500/10 rounded-full blur-3xl floating-element"
          style={{ animationDelay: "2s" }}
        ></div>
        <div
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl floating-element"
          style={{ animationDelay: "4s" }}
        ></div>
      </div>

      <div className="container-max relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Text Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
                Hi, I'm <span className="gradient-text">Spurthi</span>
              </h1>
              <h2 className="text-2xl md:text-3xl text-primary-400 font-semibold">
                {personalInfo.title}
              </h2>
              <p className="text-xl text-dark-300 leading-relaxed max-w-2xl">
                {personalInfo.about}
              </p>
            </div>

            {/* Education */}
            <div className="card card-hover">
              <h3 className="text-xl font-semibold text-white mb-3">
                Education
              </h3>
              <p className="text-dark-300">{personalInfo.education}</p>
            </div>

            {/* Skills */}
            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-white">Skills</h3>
              <div className="flex flex-wrap gap-3">
                {personalInfo.skills.map((skill, index) => (
                  <span key={index} className="skill-tag">
                    {skill}
                  </span>
                ))}
              </div>
            </div>

            {/* Contact Links */}
            <div className="flex flex-wrap gap-4">
              <a
                href={`mailto:${personalInfo.email}`}
                className="btn-primary inline-flex items-center"
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                Get in Touch
              </a>
              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary inline-flex items-center"
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                    clipRule="evenodd"
                  />
                </svg>
                LinkedIn
              </a>
            </div>
          </div>

          {/* Right Column - Profile Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="w-96 h-96 bg-gradient-to-br from-primary-500/20 via-accent-500/20 to-primary-600/20 rounded-full flex items-center justify-center shadow-2xl border border-primary-500/30 glow-effect overflow-hidden">
                <img
                  src="/profile.jpg"
                  alt="Spurthi Setty"
                  className="w-full h-full object-cover object-top rounded-full"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-6 -right-6 w-12 h-12 bg-accent-500/30 rounded-full floating-element"></div>
              <div
                className="absolute -bottom-6 -left-6 w-10 h-10 bg-primary-500/30 rounded-full floating-element"
                style={{ animationDelay: "1s" }}
              ></div>
              <div
                className="absolute top-1/2 -right-12 w-8 h-8 bg-accent-400/40 rounded-full floating-element"
                style={{ animationDelay: "3s" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
